/** The "trotro speaker": thin, a bit crunchy, like a dashboard radio. Everything from the built-in stations and AUX goes through it. */
export function createSpeaker(ctx: AudioContext): GainNode {
  const input = ctx.createGain();
  input.gain.value = 0.55;
  const highpass = ctx.createBiquadFilter();
  highpass.type = 'highpass';
  highpass.frequency.value = 160;
  const lowpass = ctx.createBiquadFilter();
  lowpass.type = 'lowpass';
  lowpass.frequency.value = 5500;
  const clip = ctx.createWaveShaper();
  const curve = new Float32Array(1024);
  for (let i = 0; i < curve.length; i += 1) {
    const x = (i / (curve.length - 1)) * 2 - 1;
    curve[i] = Math.tanh(x * 1.8);
  }
  clip.curve = curve;
  input.connect(highpass).connect(lowpass).connect(clip).connect(ctx.destination);
  return input;
}
